import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {WidgetSettingsState} from '../reducers'
import {Extra} from '../../../../settings-commons/services/redux-toolkit'

export const createAsyncAction = asyncActionsFactory<WidgetSettingsState, Extra>()
